import {React, useContext} from 'external/react'
import {styled, Box, clsx} from 'external/material'

import {TeacherContext} from 'teacher/context'

import SearchPattern from   'components/search-pattern'
import FilterChip from './Chip'
import GradeFilter from './GradeFilter'

import SelectGroup from './SelectGroup'
import SelectPeriod from './PeriodFilter'

import AddExternalGrade from '../AddExternalGrade'

import Leyend from './Leyend'

const StyledFilters = styled(Box)(filterStyles)

export default function GradeFilters(props) {
  const context = useContext(TeacherContext)
  const {query, link, groupId, translate} = context
  const isDreyfous = context.profile.domain === 'dreyfous' || context.profile.domain === 'dreyfous-dg'
  const path = link({page: 'gradebook', groupId})
  return (
    <StyledFilters>
      <Box className={clsx('filter-row', 'group')}>
        <Box className={clsx('container', 'select-group')}>
          <SelectGroup />
        </Box>
        <Box sx={{flexGrow: 1}} />
        <Box className={clsx('container', 'add-external-grade')}>
          <AddExternalGrade />
        </Box>
      </Box>
      <Box className={clsx('filter-row', 'period')}>
        <Box className={clsx('container', 'select-period')}>
          <SelectPeriod />
          <GradeFilter/>
        </Box>
        <Box sx={{flexGrow: 1}} />
        <Box sx={{display: 'flex', gap: '16px', marginRight: '16px'}}>
          <Leyend color='rgba(234, 185, 237, 1)' label={translate('adjust-grade')}/>
          <Leyend color='rgba(205, 240, 192, 1)' label={translate('manual-grade')}/>
        </Box>
        <Box className={clsx('container', 'chips')}>
          {query.pattern && <FilterChip name="pattern" path={path} />}
        </Box>
        <Box className={clsx('container', 'pattern')}>
          <SearchPattern  path={path} context={context} />
        </Box>
      </Box>
    </StyledFilters>
  )
}

function filterStyles() {
  return {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      "& .filter-row": {
        display: 'flex',
        padding: '15px 0',
        justifyContent: 'center',
        alignItems: 'center',
        "&.period": {
          border: 'solid 1px #dbe3e6',
          borderBottom: 0,
          borderRadius: 4,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          padding: 15
        },
      },
      "& .container": {
        display: 'flex',
        gap: '16px',
        // flexDirection: 'column',
        justifyContent: 'center',
        "&.export-group": {
          marginLeft: 11
        }
      },
      "& .chips": {
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center',
        marginRight: 10,
        '& .filter-chip': {
          backgroundColor: '#de3434',
          color: '#fff',
          '& .MuiChip-label': {
            padding: '0 20px'
          },
          '& .MuiChip-deleteIcon': {
          }
        }
      },
      "& .pattern": {
        border: 'solid 1px #bec4d2',
        display: 'flex',
        flexWrap: 'nowrap',
        borderRadius: '5px',
        backgroundColor: '#fff',
        padding: 0,
        height: '38px',
      }
    }
}

